import moment from "moment";
import { v4 } from 'uuid'

class AssigningValuesToTheObject {
  assigningValues(object) {
    const fornecedor = object?.fornecedor?.[0] || {};
    const enderecoEmit = fornecedor?.enderEmit?.[0] || {};
    const purchase = object?.purchase?.[0] || {};
    const impostos = object?.impostos?.[0] || {};

    const supplierTotal = {
      supplier: {
        id: "",
        nomeFantasia: this.getString(fornecedor?.xFant?.[0] ?? fornecedor?.xNome?.[0]),
        razaoSocial: this.getString(fornecedor?.xNome?.[0] ?? fornecedor?.xFant?.[0]),
        cpfCnpj: this.getString(fornecedor?.CNPJ?.[0]),
        ie: this.getString(fornecedor?.IE?.[0]),
        endereco: this.getString(enderecoEmit?.xLgr?.[0]),
        numero: this.getString(enderecoEmit?.nro?.[0]),
        bairro: this.getString(enderecoEmit?.xBairro?.[0]),
        cidade: this.getString(enderecoEmit?.xMun?.[0]),
        cep: this.getString(enderecoEmit?.CEP?.[0]),
        uf: this.getString(enderecoEmit?.UF?.[0]),
        telefone: this.getString(enderecoEmit?.fone?.[0]),
      },
      products: [],
      purchase: {
        id: "",
        idEmpresa: "",
        idFornecedor: "",
        dataCompra: moment().format("YYYY-MM-DD"),
        numeroNfe: this.getString(purchase?.nNF?.[0]),
        modeloNfe: this.getString(purchase?.mod?.[0]),
        serieNfe: this.getString(purchase?.serie?.[0]),
        dadosAdicionais: "Sem dados adicionais",
        chaveNfe: this.getString(object?.key?.[0]),
        cfop: "",
        baseIcms: this.getNumber(impostos?.vBC?.[0]),
        vIcms: this.getNumber(impostos?.vICMS?.[0]),
        vIpi: this.getNumber(impostos?.vIPI?.[0]),
        vOutros: this.getNumber(impostos?.vOutro?.[0]),
        valorNfe: this.getNumber(object?.valorNfe),
        valorFrete: this.getNumber(object?.valorFrete)
      }
    }

    supplierTotal.products = (object?.produtos || []).map((e) => {
      const icmsInfo = e?.imposto?.[0]?.ICMS?.[0] || {};
      let bcIcms, bcIcmsST, pIcms, cst;

      bcIcms = this.getPercentageIcms(icmsInfo, 'vBC');
      bcIcmsST = this.getPercentageIcms(icmsInfo, 'vBCST');
      pIcms = this.getPercentageIcms(icmsInfo, 'pICMS')
      cst = this.getCst(icmsInfo)

      return {
        id: v4(),
        nome: this.getString(e?.prod?.[0]?.xProd?.[0]),
        valor: this.getNumber(e?.prod?.[0]?.vUnCom?.[0]),
        valorVenda: 0.0,
        unidade: "UND",
        estoque: this.getNumber(e?.prod?.[0]?.qCom?.[0]),
        estoqueMin: 0,
        quantidade: this.getNumber(e?.prod?.[0]?.qCom?.[0]),
        ncm: this.getString(e?.prod?.[0]?.NCM?.[0]),
        desconto: this.getNumber(e?.prod?.[0]?.vDesc?.[0]),
        bcIcms: this.getNumber(bcIcms),
        bcIcmsST: this.getNumber(bcIcmsST),
        pIcms: this.getNumber(pIcms),
        bcIpi: this.getNumber(e?.imposto?.[0]?.IPI?.[0]?.IPITrib?.[0]?.vBC?.[0]),
        cst: this.getString(cst),
        codigo: this.getString(e?.prod?.[0]?.cProd?.[0]),
        cfop: this.handleCfop(e?.prod?.[0]?.CFOP?.[0]),
        status: "Ativo"
      };
    });

    return supplierTotal
  }

  getPercentageIcms(value, key) {
    const result = Object.keys(value || {}).map(item => {
      return key in value[item][0] ? this.getNumber(value[item][0][key][0]) : 0
    })[0]

    return this.getNumber(result)
  }

  getCst(cst) {
    const cstKey = Object.keys(cst || {})?.[0] || "";
    const matched = cstKey.match(/\d+/g);
    return matched?.[0] || "";
  }

  handleCfop(cfop) {
    if (cfop) {
      return String(cfop).startsWith('5', 0) ? `1${String(cfop).substring(1, 4)}` : `2${String(cfop).substring(1, 4)}`
    }

    return ""
  }

  getNumber(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  getString(value) {
    return value === null || value === undefined ? "" : String(value);
  }
}

export default new AssigningValuesToTheObject()